import { render, staticRenderFns } from "./NotFoundBlock.vue?vue&type=template&id=0f803cac&scoped=true&"
import script from "./NotFoundBlock.vue?vue&type=script&lang=js&"
export * from "./NotFoundBlock.vue?vue&type=script&lang=js&"
import style0 from "./NotFoundBlock.vue?vue&type=style&index=0&id=0f803cac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f803cac",
  null
  
)

export default component.exports